import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import * as userActions from "../../../Redux/Actions/user";
import * as notificationActions from "../../../Redux/Actions/notification";
import * as userAuthActions from "../../../Redux/Actions/user";
import { getLocaleValue } from "../../../utils"; 
import { getToken } from "../../../utils/pushNotification";

export default function OTPVerifyModal({
  showModal,
  handleCancel,
  history,
  footerOption1,
  footerOption2,
  email,
  t,
}) {
  const [errMsg, setErrMsg] = useState("");
  const [otp, setOTP] = useState("");
  const dispatch = useDispatch();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [fcmToken, setFcmToken] = useState("");

  // var fcmToken = localStorage.getItem("fcmToken");

useEffect(() => {
  getToken(setFcmToken);
}, []);

  const parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  };
  const handleOk = () => {
    setButtonLoading(true);
    if (email !== "") {    
      // toastMessage('error', `Enter the correct details`);
      const payload = {
        userName: email,
        otp: otp,
        fcmToken,
      };
      userActions
        .verifyOTP(payload)
        .then((res) => {
          if (res && res.status === 200) {
           
            toastMessage("success", "OTP verification Successful");
            let jwtResponse = parseJwt(res.data.data.token);
            localStorage.setItem("jwt", res.data.data.token);
            dispatch(userAuthActions.userData(jwtResponse));
            history.push(`/home`);
            setButtonLoading(false);
            getToken(setFcmToken);

            let payload = {
              id: res.data.data.id,
              fcmToken,
            };
            (fcmToken !="") && notificationActions.updateToken(payload).then((res) => {
              localStorage.setItem("fcmToken", fcmToken);
              if (res && res.data) {
                toastMessage("success", "Your notification status updated");
              } else {
                toastMessage("error", "Unable to update the FCM token");
              }
            });
          } else {
            toastMessage("error", getLocaleValue("Invalid Otp"));
          }
          setButtonLoading(false);
        })
        .catch((err) => {
          toastMessage("error", getLocaleValue("Invalid Otp"));
          setButtonLoading(false);
        });
    } else {
      setErrMsg("Please enter Valid OTP");
      setButtonLoading(false);
    }
  };

  return (
    <div>
      <div
        className="modal"
        style={{ display: showModal ? "block" : "", top: "50%" }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center">
                <label className="p-3 form-label">OTP</label>
                <input
                  type="text"
                  className="p-1 form-control"
                  required={true}
                  style={{ marginLeft: "85px", width: "53%", height: "30px" }}
                  placeholder="Enter OTP"
                  onChange={(e) => {
                    setOTP(e.target.value);
                    setErrMsg("");
                  }}
                ></input>
              </div>
            </div>

            {errMsg && <p className="text-danger text-center">{errMsg}</p>}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light-danger font-weight-bold"
                onClick={handleCancel}
              >
                {footerOption2 ? footerOption2 : "Cancel"}
              </button>
              <button
                type="button"
                className="btn btn-primary font-weight-bold d-flex align-items-center"
                onClick={handleOk}
                disabled={buttonLoading}
              >
                {footerOption1 ? footerOption1 : "Submit"}
                {buttonLoading && (
                  <Loader
                    type="Oval"
                    color="#fff"
                    height={20}
                    width={20}
                    style={{ marginLeft: "10px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
